import { render, staticRenderFns } from "./CreateResource.vue?vue&type=template&id=4be8aca3&"
import script from "./CreateResource.vue?vue&type=script&lang=js&"
export * from "./CreateResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports